import { Component, inject, signal } from '@angular/core';
import { Api } from '../../services/api';
import { catchError, of, tap, timeout } from 'rxjs';
import { FeaturedArticleItems } from '../../interface/articles';
import { TruncatePipe } from '../../pipes/truncate-pipe';
import { RouterLink } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-widget-featured',
  imports: [
    RouterLink,
    TruncatePipe,
    NgxSkeletonLoaderModule
  ],
  templateUrl: './widget-featured.html',
  styleUrl: './widget-featured.css',
})
export class WidgetFeatured {
  isLoading = signal(false);
  featured = signal<FeaturedArticleItems[]>([]);
  private api = inject(Api);

  private initialize() : void {
    this.isLoading.set(true);

    this.api.getWidgetFeaturedArticles()
    .pipe(
      timeout(10000),
      catchError(() => of([])),
      tap(() => this.isLoading.set(false))
    )
    .subscribe(featured => {
      this.featured.set(featured);
    })
  }

  ngOnInit(){
    this.initialize();
  }
}
